import ViewerLayout from 'types/viewerLayout'

/** Epub viewer layout size */
const viewerLayout: ViewerLayout = {
  MIN_VIEWER_WIDTH: 300,  
  MIN_VIEWER_HEIGHT: 300,
  VIEWER_HEADER_HEIGHT: 64,
  VIEWER_FOOTER_HEIGHT: 60,
	VIEWER_SIDEMENU_WIDTH: 0
}

export const contextmenuWidth = 160;

export default viewerLayout